import { useTranslation } from "react-i18next";
import { FlexWrapper } from "../../../../style/FlexWrapper";
import { ButtonCancel, ButtonConfirm } from "../../../Layout/Buttons";
import SubjectPaymentMethodsList from "../SubjectPaymentMethodsList";
import {
  useAddPolicySubjectContext,
  useAddPolicySubjectDispatch,
} from "./AddPolicySubjectContext";
import { SubjectPaymentMethodModal } from "../Forms/SubjectPaymentMethodForm";
import { PaymentMethod } from "../../../../redux/apiSpecifications/apiSubjects";
import { useState } from "react";

interface IPaymentMethodsStepProps {
  onNextStep: () => void;
  onPreviousStep: () => void;
}

const PaymentMethodsStep = ({
  onNextStep,
  onPreviousStep,
}: IPaymentMethodsStepProps) => {
  const { t } = useTranslation();

  const dispatch = useAddPolicySubjectDispatch();

  const { addPolicySubjectData } = useAddPolicySubjectContext();

  const [subjectPaymentMethod, setSubjectPaymentMethod] = useState<
    PaymentMethod | undefined
  >(undefined);

  const handleOnConfirmSubjectPaymentMethod = (
    subjectPaymentMethod: PaymentMethod
  ) => {
    setSubjectPaymentMethod(undefined);

    let paymentMethods: PaymentMethod[] = [];

    if (addPolicySubjectData?.paymentMethods === undefined) {
      paymentMethods.push(subjectPaymentMethod);
    } else {
      const result = addPolicySubjectData?.paymentMethods?.find(
        (_) => _.type === subjectPaymentMethod.type
      );

      if (result === undefined) {
        paymentMethods = [
          ...addPolicySubjectData?.paymentMethods!,
          subjectPaymentMethod,
        ];
      }
    }

    dispatch!({
      type: "CHANGE_POLICY_SUBJECT_DATA",
      payload: {
        value: paymentMethods,
        field: "paymentMethods",
      },
    });
  };

  const handleOnDeleteSubjectPaymentMethod = (
    subjectPaymentMethod: PaymentMethod
  ) => {
    if (addPolicySubjectData?.paymentMethods !== undefined) {
      dispatch!({
        type: "CHANGE_POLICY_SUBJECT_DATA",
        payload: {
          value: addPolicySubjectData?.paymentMethods.filter(
            (_) => _.type !== subjectPaymentMethod.type
          ),
          field: "paymentMethods",
        },
      });
    }
  };

  const enableNextButton = true;

  return (
    <>
      <FlexWrapper flexDirection="column" gap="2em">
        {(addPolicySubjectData?.paymentMethods === undefined ||
          addPolicySubjectData?.paymentMethods.length === 0) && (
          <FlexWrapper>
            <ButtonConfirm
              onClick={() => setSubjectPaymentMethod({ type: "B" })}
            >
              {t("BUTTONS.add-subject-payment-method")!}
            </ButtonConfirm>
          </FlexWrapper>
        )}

        <SubjectPaymentMethodsList
          paymentMethods={addPolicySubjectData?.paymentMethods!}
          onSelectPaymentMethod={(subjectPaymentsListItem) =>
            setSubjectPaymentMethod(
              addPolicySubjectData?.paymentMethods!.find(
                (_) => _.type === subjectPaymentsListItem.type
              )
            )
          }
          onDeletePaymentMethod={handleOnDeleteSubjectPaymentMethod}
        />

        <FlexWrapper gap="1em" justifyContent="flex-end">
          <ButtonCancel onClick={onPreviousStep}>
            {t("BUTTONS.previous")!}
          </ButtonCancel>

          <ButtonConfirm onClick={onNextStep} disabled={!enableNextButton}>
            {t("BUTTONS.next")!}
          </ButtonConfirm>
        </FlexWrapper>
      </FlexWrapper>

      <SubjectPaymentMethodModal
        open={subjectPaymentMethod !== undefined}
        subjectPaymentMethod={subjectPaymentMethod}
        onCancel={() => setSubjectPaymentMethod(undefined)}
        onConfirm={handleOnConfirmSubjectPaymentMethod}
      />
    </>
  );
};

export default PaymentMethodsStep;
